import VehicleGroupFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => (
  <GenericEditForm formLayoutComponent={<VehicleGroupFormLayout />} transformValues={transformValues} />
)
